import { z } from 'zod'

const CM_LAYOUTS = ['dual_cta', 'pro_section'] as const

export type CmLayout = (typeof CM_LAYOUTS)[number]

const CmLayoutVariablesSchema = z.object({
  cmLayout: z.enum(CM_LAYOUTS).nullish(),
})

export const parseCmLayout = (
  variables: unknown,
): { cmLayout?: CmLayout; isInvalid: boolean } => {
  const parsed = CmLayoutVariablesSchema.safeParse(variables ?? {})

  return parsed.success
    ? { cmLayout: parsed.data.cmLayout ?? undefined, isInvalid: false }
    : { isInvalid: true }
}
